import { StepBase } from './StepBase'
import { PageStepType } from './PageTypes';
import { LogicEngine } from '../LogicEngine/LogicEngine';
import { DataTools } from '../utils/DataTools';
import { DataQuery } from '../utils/DataQuery';

export class StepLookup extends StepBase
{
    /** Value from the query or other options */
    count: number = 0;

    /** Process the query associated with the stat */
    async processStep(logic: LogicEngine): Promise<boolean>
    {
        await super.processStep(logic);

        //  Usage for Lookup
        //  If the option is "Group", text= Query, Field = List of fields.

        if (this.options.checkOption('Group') || this.options.checkOption('GroupBy'))
        {
            const fieldList = DataTools.internalValidateString(this.field_id).split(',');
            const queryText = DataTools.internalValidateString(this.text);

            // Lookup the records
            if (LogicEngine.debugOutput)
                console.log("StepLookup Group, Query=", queryText, "fields=", fieldList);

            const records = await DataQuery.instance().executeQueryByText(queryText);
            if (!records || records.length == 0)
            {
                if (LogicEngine.debugOutput)
                    console.log("StepLookup no results.");
                return true;
            }

            //  Loop through results, count the values in the group.
            //  INCOMPLETE
        }

        return true;
    }

    /**
     * The data for Dash Button is <text to show>;<table to count results from>
     */
    constructor(rawData: PageStepType)
    {
        super(rawData);
    }
}
